import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type WhatsappPhoneFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const WhatsappPhoneFilled = ({ size = 24, width, height, alt = '', color = 'currentColor', strokeWidth, style, ...props }: WhatsappPhoneFilledProps) =>
  h(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      fill: color,
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      color,
      "stroke-width": strokeWidth,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'translate(0.500004 0.5) scale(0.71875)',
        },
        [
          h(
            'path',
            {
              d: 'M15.9749 6.1512e-05C9.97312 0.00199244 4.47846 3.37096 1.74864 8.72275C-0.981185 14.0746 -0.485794 20.5066 3.03126 25.3761L1.59308 29.76C1.49421 30.0463 1.56886 30.364 1.78484 30.576C1.99702 30.7912 2.31064 30.8713 2.59981 30.784L7.15406 29.312C12.8528 33.1167 20.3394 32.8618 25.7669 28.6784C31.1944 24.495 33.3555 17.3135 31.1398 10.8242C28.9241 4.33488 22.8243 -0.0188725 15.9749 6.1512e-05ZM25.2752 22.5921C24.61 23.7934 23.4328 24.6244 22.0792 24.8481C21.2483 25.0241 20.1457 25.1681 16.4863 23.6481C13.233 22.0728 10.4705 19.6388 8.49637 16.6081C7.41309 15.2254 6.75266 13.5583 6.59477 11.8081C6.54436 10.3377 7.12619 8.91619 8.19275 7.9041C8.63658 7.52195 9.20546 7.31689 9.79073 7.3281H10.3181C10.7815 7.3281 11.0212 7.3281 11.3408 8.1121C11.6604 8.8961 12.6511 11.3121 12.763 11.5681C12.9335 11.8241 12.9635 12.149 12.8429 12.4321C12.7059 12.7031 12.528 12.9513 12.3155 13.1681C12.0918 13.4401 11.8521 13.6481 11.6284 13.9361C11.3099 14.1694 11.2261 14.6098 11.4367 14.9441C12.1409 16.1302 13.0128 17.208 14.0254 18.1441C15.1193 19.1483 16.3936 19.9356 17.7806 20.4641C18.1536 20.6455 18.5999 20.5753 18.8992 20.2881C19.3481 19.7817 19.7644 19.2473 20.1457 18.6881C20.3866 18.2975 20.8834 18.1524 21.2962 18.3521C21.7277 18.4961 24.0128 19.6321 24.4922 19.8561C24.9716 20.0801 25.2752 20.2081 25.387 20.4001C25.5546 21.1269 25.5159 21.8861 25.2752 22.5921Z',
            },
          ),
        ],
      ),
    ],
  );

export default WhatsappPhoneFilled;
